import { jsx, jsxs } from "react/jsx-runtime";
const Browser = ({ className, color: colorProp = '#181B32', secondaryColor: secondaryColorProp = 'var(--color-primary-light-400)', size = 32, ignoreColor })=>{
    const color = ignoreColor ? void 0 : colorProp;
    const secondaryColor = ignoreColor ? void 0 : secondaryColorProp;
    return /*#__PURE__*/ jsxs("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M44 44H4V7C4 5.35 5.35 4 7 4H41C42.65 4 44 5.35 44 7V44ZM6 42H42V7C42 6.45 41.55 6 41 6H7C6.45 6 6 6.45 6 7V42Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M40 8H38V10H40V8Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M36 8H34V10H36V8Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M32 8H30V10H32V8Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M43 12H5V14H43V12Z",
                fill: secondaryColor
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M22 30H9V17H22V30ZM11 28H20V19H11V28Z",
                fill: secondaryColor
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M39 33H9V35H39V33Z",
                fill: secondaryColor
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M39 17H25V19H39V17Z",
                fill: secondaryColor
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M35 22H25V24H35V22Z",
                fill: secondaryColor
            })
        ]
    });
};
const pictograms_Browser = Browser;
export default pictograms_Browser;
